import { render, staticRenderFns } from "./Readme.vue?vue&type=template&id=43045f96&"
import script from "./Readme.vue?vue&type=script&lang=js&"
export * from "./Readme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports